var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombineDatasetsOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86914 7.19727C4.86914 7.19727 10.0001 8.83527 10.0001 10.1973V12.4353",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.063 7.19727C15.063 7.19727 10 8.83527 10 10.1973V12.4353",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0C3.874 0 4.987 0.586 4.987 1.308C4.987 2.03 3.873 2.617 2.5 2.617C1.127 2.617 0.012 2.03 0.012 1.308C0.012 0.586 1.126 0 2.5 0ZM0.012 4.377V5.377C0.455 7.144 4.827 6.802 4.987 5.287V4.287C4.769 5.952 0.362 6.071 0.012 4.377ZM0 1.762V2.743C0.443 4.469 4.839 4.235 5 2.755V1.775C4.781 3.4 0.35 3.417 0 1.762ZM0 3.03V4.03C0.443 5.8 4.839 5.562 5 4.046V3.046C4.781 4.707 0.35 4.724 0 3.03Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 0C18.874 0 19.987 0.586 19.987 1.308C19.987 2.03 18.873 2.617 17.5 2.617C16.127 2.617 15.012 2.03 15.012 1.308C15.012 0.586 16.126 0 17.5 0ZM15.012 4.377V5.377C15.455 7.144 19.827 6.802 19.987 5.287V4.287C19.769 5.952 15.362 6.071 15.012 4.377ZM15 1.762V2.743C15.443 4.469 19.839 4.235 20 2.755V1.775C19.781 3.4 15.35 3.417 15 1.762ZM15 3.03V4.03C15.443 5.8 19.839 5.562 20 4.046V3.046C19.781 4.707 15.35 4.724 15 3.03Z",
    fill: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.4277C11.374 13.4277 12.487 14.0137 12.487 14.7357C12.487 15.4577 11.373 16.0447 10 16.0447C8.627 16.0447 7.512 15.4577 7.512 14.7357C7.512 14.0137 8.626 13.4277 10 13.4277ZM7.512 17.8047V18.8047C7.955 20.5717 12.327 20.2297 12.487 18.7147V17.7147C12.269 19.3797 7.862 19.4987 7.512 17.8047ZM7.5 15.1897V16.1707C7.943 17.8967 12.339 17.6627 12.5 16.1827V15.2027C12.281 16.8277 7.85 16.8447 7.5 15.1897ZM7.5 16.4577V17.4577C7.943 19.2277 12.339 18.9897 12.5 17.4737V16.4737C12.281 18.1347 7.85 18.1517 7.5 16.4577Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombineDatasetsOperationIcon);
export default __webpack_public_path__ + "static/media/CombineDatasetsOperationIcon.33c22a55973ce36fe4f7ac1d900c6981.svg";
export { ForwardRef as ReactComponent };